// #region imports

// --- Angular
import { Component, OnInit, ChangeDetectionStrategy, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';

// --- 3rd Party
import { User as OidcUser } from 'oidc-client';

// #endregion

@Component({
  selector: 'hs-dashboard-side-nav-links',
  templateUrl: './dashboard-side-nav-links.component.html',
  styleUrls: ['./dashboard-side-nav-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardSideNavLinksComponent implements OnChanges {

  @Input() user: OidcUser | null = null;
  @Input() isParticipant: boolean = false;
  @Input() isRespondent: boolean = false;

  @Output() logout = new EventEmitter();
  @Output() linkClicked = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['user'] && changes['user'].currentValue) {
      if (this.user && this.user.profile) {
        if (this.user.profile['surveyparticipant']) {
          this.isParticipant === (this.user.profile['surveyparticipant'].toLowerCase() === 'true');
        }
        if (this.user.profile['surveyrespondent']) {
          this.isRespondent === (this.user.profile['surveyrespondent'].toLowerCase() === 'true');
        }
      }
    }
  }

  linkClick() {
    this.linkClicked.emit();
  }

  logoutClick() {
    this.logout.emit();
  }
}
